import { WineLabelsApi } from '../../api';
import axios from '../axios';

const wineLabelApi = new WineLabelsApi(undefined, undefined, axios);

export default wineLabelApi;
